import React, { useEffect } from "react";

import HeaderBanner from "../../../components/HeaderBanner/index";

const CampusTour = () => {
  useEffect(() => {
    document.title = "Campus Tour";
  }, []);

  return (
    <div>
      {/* Banner */}
      <HeaderBanner
        bgImage="Management"
        title="Campus Tour"
        currentPage="Campus Tour"
      />
      <div className="bannerBotttom h-[3.5rem] w-full"></div>

      {/* Content */}
      <div className="mx-auto max-w-[1300px] px-4">
        {/* Heading */}
        <div className="primary-color mt-8 w-72 border-l-4 border-[#32727a] pl-3 text-2xl font-bold md:w-[28rem] md:text-[45px]">
          Campus Tour
        </div>

        {/* Video Section */}
        <div className="mt-10 bg-gray-100 p-6 rounded-xl">
          <h2 className="text-2xl font-bold mb-6 text-center">
            Campus Tour Video
          </h2>

          <div className="flex justify-center">
            <div className="w-full max-w-[900px] aspect-video">
              <iframe
                src="https://drive.google.com/file/d/1i5D_XT5yq-QRFSSwrWO1Lv59alvvuT19/preview"
                className="w-full h-full rounded-lg shadow-lg"
                allow="autoplay"
                allowFullScreen
                title="Campus Tour Video"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampusTour;
